export default {
  props: {
    name: {
      type: String,
      default: 'faq-search-input',
    },
    placeholder: {
      type: String,
      default: 'Search FAQs',
    },
    initial: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      value: this.initial,
    };
  },
  computed: {
    hasValueModifier() {
      return this.value ? 'faq-search-input--has-value' : '';
    },
  },
  methods: {
    updateSearch(e) {
      const value = e.target.value;
      this.value = value;
      this.$emit('search', value);
    },
    focusInput() {
      this.$refs.input.focus();
    },
  },
  mounted() {
    if (this.initial) {
      this.$emit('init', this.initial);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/support/faq-search-input/faq-search-input.js